var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgOpenBook = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.6C11.3 5.75 9.95 5 8.2 5C6.45 5 4.85 5.5 3.6 6.2V18.6C4.85 17.9 6.45 17.4 8.2 17.4C9.95 17.4 11.3 18.15 12 19C12.7 18.15 14.05 17.4 15.8 17.4C17.55 17.4 19.15 17.9 20.4 18.6V6.2C19.15 5.5 17.55 5 15.8 5C14.05 5 12.7 5.75 12 6.6Z",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.6V19",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 9.1C6.25 8.9 7.2 8.8 8.2 8.8C8.8 8.8 9.4 8.85 10 8.95",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 12.1C6.25 11.9 7.2 11.8 8.2 11.8C8.8 11.8 9.4 11.85 10 11.95",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.95C14.6 8.85 15.2 8.8 15.8 8.8C16.8 8.8 17.75 8.9 18.6 9.1",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.95C14.6 11.85 15.2 11.8 15.8 11.8C16.8 11.8 17.75 11.9 18.6 12.1",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOpenBook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/open-book.052b64bb.svg";
export { ForwardRef as ReactComponent };